import BlFlexContainerMv from './BlFlexContainerMv.vue'

BlFlexContainerMv.install = function(Vue) {
  Vue.component(BlFlexContainerMv.name, BlFlexContainerMv)
}

export default BlFlexContainerMv
